export const Screens = {
  HOME: 'marketplace homepage',
  APPS: 'apps product homepage',
  AGENTS: 'agents product homepage',
  SEARCH_RESULTS: 'search results',
  FEATURED: 'featured collections',
  FEATURED_COLLECTION: 'collection search results',
  UMBRELLA_COLLECTION: 'umbrella collection',
  LISTING_DETAILS: 'listing details'
};